module.exports = __webpack_public_path__ + "media/images/buddy_blank_big-5bc8decf43d2576aad2db7bbb3072ffb.png";